module.exports = __webpack_public_path__ + "media/assets/images/flags/pw-7700de59bd96c4646694b3f6d655b816.svg";